import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import DesignFolderSave from "./DesignFolderSave";
import DesignSave from "../Design/DesignSave";
import UploadFile from "./DesignFolderUploadFile";
import DeleteFile from "./DesignFolderDeleteFile";
import GetDesignFolderDetails from "./DesignFolderGetDetails";
import DeleteEductorSelection from "./DesignFolderDeleteEductor";
import GetEductors from "./DesignFolderGetEductors";
import ExtendedDescription from "../Tools/ExtendedDescription";

const DesignFolderDetails = () => {

    const { id } = useParams();
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    let response25 = useInvoke("WebApps", "25", { "@DesignFolderId": id });
    let response83 = useInvoke("WebApps", "83", { "@DesignFolderId": id });
    const [details, setDetails] = useState([]);
    const [notes, setNotes] = useState("");
    const [designList, setDesignList] = useState([]);
    const [eductorSelections, setEductorSelections] = useState([]);

    const [confirmDelete, setConfirmDelete] = useState(null);

    useEffect(() => {

        //get design folder details
        if (response25.data.payload != undefined) {
            handleDesignDetails(JSON.parse(response25.data.payload).data[0]);
        }

        //get eductor selections
        if (response83.data.payload != undefined) {

            let data = JSON.parse(response83.data.payload).data;

            handleEductorDetails(data);

        }

    }, [response25.isPending, response83.isPending]);

    const handleEductorDetails = (data) => {

        let eductors = [];

        data.forEach((ed, index) => {

            const dateString = ed[4];
            const date = new Date(dateString);
            const shortDate = date.toLocaleDateString("en-US", {
                month: "numeric",
                day: "numeric",
                year: "2-digit",
            });

            let obj = {
                "key": index,
                "id": ed[0],
                "name": ed[1],
                "designid": ed[2],
                "designnum": ed[3],
                "createddate": shortDate
            };

            eductors.push(obj);

        });

        setEductorSelections(eductors);

    };

    const handleDesignDetails = (data) => {
        let entry = data;

        let num = entry[0].toString(); while (num.length < 6) num = "0" + num;
        entry["DesignNum"] = `DP#${num}`;
        entry["Created Date"] = entry[1];
        entry["Created By"] = entry[2];
        entry["ReferenceNum"] = entry[3];
        entry["CustomerReferenceNum"] = entry[4];
        entry["CustomerName"] = entry[5];
        entry["Address"] = entry[6];
        entry["City, State, Zip"] = entry[7];
        entry["LocationName"] = entry[8];
        entry["Site Address"] = entry[9];
        entry["Site City, State, Zip"] = entry[10];
        entry["Elevation"] = entry[11];
        entry["Velocity"] = entry[12];
        entry["Factor"] = entry[13];
        entry["EntrySize"] = entry[14];
        entry["Industry"] = entry[15];
        entry["Materials Hdld"] = entry[16];
        entry["MaterialDetails"] = entry[17];
        entry["Notes"] = entry[18];
        entry["Designs"] = [];

        if (entry[19]) {
            let designs = entry[19].split("|");

            function parseInfo(str) {
                // Regular expression to capture:
                // 1. text inside the parenthesis,
                // 2. the name after "created by",
                // 3. and the date after "on"
                const regex = /^\(([^)]+)\)\s+created by\s+(.+?)\s+on\s+(\d{2}\/\d{2}\/\d{4})$/i;
                const match = str.match(regex);

                if (match) {
                    // Trim in case there are any extra spaces
                    return [match[1].trim(), match[2].trim(), match[3].trim()];
                } else {
                    return ["Invalid String", "Invalid String", "Invalid String"];
                }
            }

            designs.forEach((line, index) => {
                line = line.split("‡");

                let statusUserDate = parseInfo(line[2]);

                let status = statusUserDate[0];
                let createdBy = statusUserDate[1];
                let createdDate = statusUserDate[2];

                let designConfig = {};

                let sequence = line[1];

                let text = line[2];
                let num = entry[0].toString(); while (num.length < 6) num = "0" + num;
                let linkText = `DES#${num}`;

                if (sequence != undefined) {
                    while (sequence.toString().length < 2) {
                        sequence = `0${sequence}`;
                    }
                }

                linkText = `${linkText}-${sequence.toString()}`;

                designConfig["id"] = line[0];
                designConfig["linkText"] = linkText;
                designConfig["bodyText"] = text;
                designConfig["createdDate"] = line[3];
                designConfig["notes"] = line[4];
                designConfig["key"] = index + 1;
                designConfig["status"] = status;
                designConfig["createdBy"] = createdBy;
                designConfig["createdDate"] = createdDate;
                entry["Designs"].push(designConfig);

            });

            setDesignList(entry["Designs"]);

        }

        entry["Attachments"] = [];
        if (entry[20]) {
            let attachments = entry[20].split("|");

            attachments.forEach((line, index) => {
                line = line.split("‡");

                entry["Attachments"].push({
                    "key": index,
                    "URL": `https://dc.cssi.co/Attachments/${line[0]}`,
                    "FileName": line[0],
                    "suffix": line[1],
                    "DisplayName": line[2]
                });
            });

        }

        entry["CreatedByID"] = entry[21];
        entry["EntryFactorID"] = entry[22];
        entry["SiteLocationID"] = entry[23];
        entry["AddressID"] = entry[24];

        entry.splice(0, 25);

        setDetails(entry);
    }

    const handleDeleteDesign = (e, design) => {

        let designid = design["id"];
        let designfolderid = id;

        let modifiedbyid = user["id"];
        let deleted = "1";

        let notes = "";
        let completedate = "";
        designList.forEach((d, index) => {
            if (d.id == design["id"]) {
                notes = d.notes;
                if (d.completedate != undefined) {
                    completedate = d.completedate;
                }
            }
        });

        DesignSave(designid, designfolderid, notes, modifiedbyid, deleted, completedate).then((response) => {
            GetDesignFolderDetails(id)
                .then((response) => {
                    toast.success('Successfully deleted design');
                    handleDesignDetails(JSON.parse(response.payload).data[0]);
                })
        });
    };

    const handleDeleteEductor = (e, eductorid, designid) => {

        DeleteEductorSelection(eductorid, designid)
            .then((response) => {
                if (response.success) {
                    toast.success('Successfully deleted eductor selection');

                    GetEductors(id)
                        .then((response) => {

                            let breakpoint = "";
                            handleEductorDetails(JSON.parse(response.payload).data);

                        });
                }
                else {
                    toast.error('Error removing eductor selection');
                }
            });

    };

    const handleFormSubmit = (e) => {
        e.preventDefault(); // Assuming you want to prevent default form submission behavior

        const designfolderid = id;
        const userid = details["CreatedByID"];
        const entryfactorid = details["EntryFactorID"];
        const velocity = details["Velocity"];
        const entrysize = details["EntrySize"];
        const notes = document.getElementById("projectnotes").value;
        const modifiedbyid = user["id"];
        const referencenum = document.getElementById("referencenum").value;
        const customerreferencenum = document.getElementById("customerreferencenumber").value;
        const address = details["AddressID"] || details["AddressID"] === 0 ? details["AddressID"] : -1; //Replace falsy with -1
        const materialdetails = document.getElementById("materialdetails").value;
        let elevation = document.getElementById("elevationinput").value;

        try {
            elevation = parseInt(elevation, 10);
            if (isNaN(elevation)) {
                throw new Error('Elevation must be a valid number.');
            }
            // Proceed with saving if elevation is valid
            DesignFolderSave(designfolderid, userid, entryfactorid, velocity, entrysize, notes, modifiedbyid, "0", referencenum, customerreferencenum, address, materialdetails, elevation)
                .then((response) => {
                    if (response.success) {
                        toast.success('Saved Successfully');
                    } else {
                        toast.error(response.error || "An error occurred during save.");
                    }
                })
                .catch((error) => {
                    toast.error("An unexpected error occurred.");
                    console.error(error); // It's good practice to log the error for debugging
                });
        } catch (error) {
            toast.error(error.message);
        }
    };


    const handleUpload = (e) => {

        let fileToUpload = document.getElementById("fileUpload").files[0];
        let designfolderid = id;
        let userid = user["id"];
        let designid = document.getElementById("DesignId").value;
        let notes = document.getElementById("fileNotes").value;

        UploadFile(fileToUpload, designfolderid, userid, designid, notes).then((response) => {

            if (response.status == 200) {
                toast.success("Attachment successfully added");
                GetDesignFolderDetails(id)
                    .then((response) => {
                        handleDesignDetails(JSON.parse(response.payload).data[0]);
                    })
            }
            else {
                toast.error("Attachment upload failed.");
            }
        });
    };

    const handleDeleteAttachment = (e, attachment) => {

        let fileToDelete = attachment["FileName"];

        DeleteFile(fileToDelete).then((response) => {

            if (response == "Successfully deleted file.") {
                toast.success("Attachment successfully deleted");
                GetDesignFolderDetails(id)
                    .then((response) => {
                        handleDesignDetails(JSON.parse(response.payload).data[0]);
                    })
            }
            else {
                toast.error("Attachment deletion failed.");
            }
        });
    };

    const handleAddNewDesign = (e) => {

        DesignSave("", id, "", user["id"], "0", "")
            .then((response) => {

                GetDesignFolderDetails(id)
                    .then((response) => {
                        toast.success("Successfully created new design");
                        handleDesignDetails(JSON.parse(response.payload).data[0]);
                    })
            });
    };

    const clearElements = (e) => {

        document.getElementById("fileUpload").value = "";
        document.getElementById("DesignId").value = "";
        document.getElementById("DisplayName").value = "";

    }

    document.title = `Design Details - ${details["DesignNum"]}`;
    return (
        <div className="details">
            {user["email"] != undefined &&
                <>
                    <div className="container body-content" style={{ marginTop: "25px" }}>

                        <div className="" style={{ width: "100%", marginTop: "32px", display: "flex", justifyContent: "space-between" }}>

                            <Link className="btn btn-default" to="/DesignFolder" style={{ width: "auto" }}>Close</Link>

                            <button onClick={handleFormSubmit} className="btn btn-success" style={{ width: "auto" }}>Save Changes</button>

                        </div>

                        <div style={{ width: "100%", marginTop: "8px", display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                            <div className="" style={{ display: "flex", flexDirection: "column" }}>
                                <h4>{details["DesignNum"]}</h4>
                                <h5>Created {details["Created Date"]} by {details["Created By"]}</h5>

                                <h5>Compass Ref #&nbsp;&nbsp;
                                    <input className="form-control ReferenceNum" autoComplete="off" id="referencenum" name="referencenum" style={{ display: "inline" }} type="text" defaultValue={details["ReferenceNum"]} />
                                </h5>

                                <h5>Customer Ref #
                                    <input className="form-control CustomerReferenceNum" autoComplete="off" id="customerreferencenumber" name="customerreferencenumber" style={{ display: "inline" }} type="text" defaultValue={details["CustomerReferenceNum"]} />
                                </h5>

                            </div>

                            <div className="" style={{ display: "flex", flexDirection: "column" }}>
                                <h4>Customer</h4>
                                <h5>{details["CustomerName"]}</h5>
                                <h5>{details["Address"]}</h5>
                                <h5>{details["City, State, Zip"]}</h5>
                            </div>

                            <div className="" style={{ display: "flex", flexDirection: "column" }}>
                                <h4>Site Location</h4>
                                <h5>{details["LocationName"]}</h5>
                                <h5>{details["Site Address"]}</h5>
                                <h5>{details["Site City, State, Zip"]}</h5>



                                <h5>Elevation (FASL)&nbsp;&nbsp;
                                    <input type="number" className="form-control ReferenceNum" autoComplete="off" id="elevationinput" name="elevationinput" style={{ display: "inline" }} defaultValue={details["Elevation"]} />
                                </h5>

                            </div>

                            <div className="" style={{ display: "flex", flexDirection: "column" }}>
                                <h4>Project Design Parameters</h4>
                                <h5>Velocity: {details["Velocity"]}</h5>
                                <h5>Entry Loss Factor: {details["Factor"]}</h5>
                                <h5>Entry Diameter: {details["EntrySize"]}''</h5>
                            </div>
                        </div>

                        <div style={{ width: "100%", marginTop: "32px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start" }}>
                            <div style={{ width: "20%" }}>
                                <h5>Industry:</h5>
                                <Link className="btn btn-primary" to={`/Sites/Edit/${details["AddressID"]}`}>
                                    Edit Site/Industries
                                </Link>
                            </div>
                            <div style={{ width: "80%" }}>
                                <textarea className="form-control" cols="20" id="DesignFolder_SiteLocation_IndustriesString" name="DesignFolder.SiteLocation.IndustriesString" readOnly="readonly" rows="2" style={{ minHeight: "76px", height: "76px", width: "100%", maxWidth: "100%" }}
                                    defaultValue={details["Industry"]}>
                                </textarea>
                            </div>
                        </div>

                        <div style={{ width: "100%", marginTop: "8px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start" }}>
                            <div style={{ width: "20%" }}>
                                <h5>Materials Handled:</h5>
                            </div>
                            <div style={{ width: "80%" }}>
                                <textarea className="form-control" cols="20" id="DesignFolder_MaterialsHandledString" name="DesignFolder.MaterialsHandledString" readOnly="readonly" rows="2" style={{ minHeight: "76px", height: "76px", width: "100%", maxWidth: "100%" }}
                                    defaultValue={details["Materials Hdld"]}>
                                </textarea>
                            </div>
                        </div>

                        <div style={{ width: "100%", marginTop: "8px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start" }}>
                            <div style={{ width: "20%" }}>
                                <h5>Materials Handled Notes:</h5>
                            </div>
                            <div style={{ width: "80%" }}>
                                <textarea className="form-control MaterialDetails" cols="20" id="materialdetails" name="materialdetails" rows="4" style={{ minHeight: "76px", width: "100%", maxWidth: "100%" }}
                                    defaultValue={details["MaterialDetails"]}>
                                </textarea>
                            </div>
                        </div>

                        <div style={{ width: "100%", marginTop: "8px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start" }}>
                            <div style={{ width: "20%" }}>
                                <h5>Project Notes:</h5>
                            </div>
                            <div style={{ width: "80%" }}>
                                <textarea className="form-control Notes" cols="20" id="projectnotes" name="projectnotes" rows="4" style={{ minHeight: "76px", width: "100%", maxWidth: "100%" }}
                                    defaultValue={details["Notes"]}>
                                </textarea>
                            </div>
                        </div>

                        <div style={{ width: "100%", marginTop: "8px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start" }}>
                            <div style={{ width: "20%" }}>
                                <h5>File Attachments:</h5>
                                <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#uploadModal">Attach New File</button>
                            </div>
                            <div style={{ width: "80%", border: "1px lightgray solid", padding: "8px", minHeight: "76px" }}>
                                {details["Attachments"] &&
                                    details["Attachments"].map((a, i2) => (
                                        <div key={i2}>

                                            <Link to={`${a["URL"]}`} target="_blank">{a["DisplayName"]}</Link>
                                            &nbsp;{a["suffix"]}&nbsp;
                                            &nbsp;<button onClick={(e) => { handleDeleteAttachment(e, a) }} className="glyphicon glyphicon-trash btn btn-default" style={{ cursor: "pointer", borderRadius: "4px", padding: "4px" }}></button>
                                            <br />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        <div style={{ width: "100%", marginTop: "8px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start" }}>
                            <div style={{ width: "20%" }}>
                                <h5>Eductor Selections:</h5>
                                <Link to="/Eductor" className="btn btn-primary">Eductors</Link>
                            </div>
                            <div style={{ width: "80%", border: "1px lightgray solid", padding: "8px", minHeight: "76px" }}>
                                {eductorSelections && (
                                    eductorSelections.map((ed, i3) => (
                                        <div key={i3}>
                                            <Link to={`/Eductor/Details/Print/${ed["id"]}`}>{ed["name"]} </Link>
                                            Attached to #{ed["designnum"]}&nbsp;
                                            On {ed["createddate"]}
                                            &nbsp;<button onClick={(e) => { handleDeleteEductor(e, ed["id"], ed["designid"]) }} className="glyphicon glyphicon-trash btn btn-default" style={{ cursor: "pointer", borderRadius: "4px", padding: "4px" }}></button>
                                        </div>
                                    ))

                                )}
                            </div>
                        </div>

                        <div style={{ width: "100%", marginTop: "8px", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-start" }}>
                            <div style={{ width: "20%" }}>
                                <h5>Design Configurations:</h5>

                            </div>
                            <div style={{ width: "80%", border: "1px lightgray solid", padding: "8px" }}>
                                {/* {details["Designs"] && details["Designs"].map((d, i1) => (
                                    <div key={i1}>
                                        <Link to={`/Design/Edit/${d["id"]}`}>{d["linkText"]}</Link>
                                        &nbsp;{d["bodyText"]}&nbsp;
                                        &nbsp;<button onClick={(e) => { handleDeleteDesign(e, d) }} className="glyphicon glyphicon-trash btn btn-default" style={{ cursor: "pointer", borderRadius: "4px", padding: "4px" }}></button>
                                        <br />
                                    </div>
                                ))} */}

                                <table className="table table-striped table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "20%" }}>Design</th>
                                            <th style={{ width: "25%" }}>Notes</th>
                                            <th>Status</th>
                                            <th>Created By</th>
                                            <th>Date Created</th>
                                            <th style={{ width: "15%" }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {designList && designList.map((d, i1) => (
                                            <tr key={i1}>
                                                <td style={{ textAlign: "left", verticalAlign: "middle" }}>
                                                    <Link to={`/Design/Edit/${d["id"]}`}><b>{d["linkText"]}</b></Link>

                                                </td>
                                                <td style={{ textAlign: "left", verticalAlign: "middle" }}><ExtendedDescription text={d["notes"]} /></td>
                                                <td style={{ textAlign: "left", verticalAlign: "middle" }}>{d["status"]}</td>
                                                <td style={{ textAlign: "left", verticalAlign: "middle" }}>{d["createdBy"]}</td>
                                                <td style={{ textAlign: "left", verticalAlign: "middle" }}>{d["createdDate"]}</td>

                                                {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                    <button onClick={(e) => { handleDeleteDesign(e, d) }} className="glyphicon glyphicon-trash btn btn-default" style={{ cursor: "pointer", borderRadius: "4px", padding: "4px" }}></button>
                                                </td> */}

                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                    {confirmDelete === i1 ? (
                                                        <div>
                                                            <span>Are you sure?</span>
                                                            <div style={{ display: "flex", justifyContent: "center", marginTop: "4px" }}>
                                                                <button
                                                                    className="btn btn-danger btn-sm"
                                                                    style={{ width: "48%", margin: "1%" }}
                                                                    onClick={(e) => {
                                                                        handleDeleteDesign(e, d);
                                                                        setConfirmDelete(null);
                                                                    }}
                                                                >
                                                                    Yes
                                                                </button>
                                                                <button
                                                                    className="btn btn-secondary btn-sm"
                                                                    style={{ width: "48%", margin: "1%" }}
                                                                    onClick={() => setConfirmDelete(null)}
                                                                >
                                                                    No
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <button
                                                            onClick={() => setConfirmDelete(i1)}
                                                            className="btn btn-danger btn-sm"
                                                            style={{ cursor: "pointer", borderRadius: "4px", padding: "4px", width: "100%" }}
                                                        >
                                                            Delete
                                                        </button>
                                                    )}
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <div style={{ display: "flex", justifyContent: "center", marginTop: "4px" }}>
                                    <button onClick={(e) => { handleAddNewDesign(e) }} className="btn btn-primary" style={{ width: "50%" }}>Add New Design</button>
                                </div>

                            </div>
                        </div>

                        <div className="" style={{ width: "100%", marginTop: "32px", display: "flex", justifyContent: "space-between" }}>

                            <Link className="btn btn-default" to="/DesignFolder" style={{ width: "auto" }}>Close</Link>

                            <button onClick={handleFormSubmit} className="btn btn-success" style={{ width: "auto" }}>Save Changes</button>

                        </div>
                    </div>
                </>
            }

            {user["email"] == undefined && <LoginRedirect />}

            {/* File Upload Modal */}
            <div className="modal" id="uploadModal" role="dialog" tabIndex="-1">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h4 className="modal-title">Add File to Design</h4>
                            <button onClick={clearElements} type="button" className="close" data-bs-dismiss="modal" aria-label="Close" style={{ position: "absolute", right: "8px", top: "12px", marginRight: "8px" }}><span aria-hidden="true">×</span></button>
                        </div>

                        <div className="modal-body">

                            <div className="form-group">
                                Design
                                <select className="form-control" id="DesignId" name="DesignId">

                                    <option value="">Select Design</option>

                                    {designList &&
                                        designList.map((d, i3) => (
                                            <option key={i3} value={d["id"]}>{d["linkText"]}</option>
                                        ))
                                    }

                                </select>
                            </div>

                            <div className="form-group">
                                Notes
                                <input className="form-control" id="fileNotes" name="fileNotes" type="text" autoComplete="off" />
                            </div>

                            <div className="form-group">
                                Select File to Upload
                                <input type="file" name="fileUpload" id="fileUpload" required="required" placeholder="Select a File" className="form-control" autoComplete="off" />
                            </div>

                        </div>

                        <div className="modal-footer">
                            <button onClick={clearElements} className="btn btn-default" data-bs-dismiss="modal">Close</button>
                            <button onClick={(e) => { handleUpload(e) }} className="btn btn-primary" id="btnImgSubmit" autoComplete="off">Upload</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    );
}

export default DesignFolderDetails;